import { useEffect, useRef, useState } from "react";
import { makeStyles, tokens } from "@fluentui/react-components";
import { previewTemplate } from "../api";

const useStyles = makeStyles({
  frame: {
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: "4px",
    background: "#fff",
    // Scroll wide signatures horizontally instead of clipping them.
    overflowX: "auto",
    overflowY: "hidden",
  },
  inner: { transformOrigin: "top left" },
});

/**
 * Renders template HTML with sample data (via the backend) inside a scaled box.
 * @param {string} html  template source
 * @param {number} scale 0–1 zoom (thumbnails use ~0.6)
 * @param {number} width box width in px (content rendered at width/scale)
 */
export default function SignaturePreview({ html, scale = 1, width = 360, height }) {
  const styles = useStyles();
  const [rendered, setRendered] = useState("");
  const reqId = useRef(0);

  useEffect(() => {
    const id = ++reqId.current;
    previewTemplate(html)
      .then((r) => {
        if (id === reqId.current) setRendered(r.html || "");
      })
      .catch((e) => {
        if (id === reqId.current) setRendered(`<span style="color:#a80000">Preview error: ${e.message}</span>`);
      });
  }, [html]);

  return (
    <div className={styles.frame} style={{ width, height }}>
      <div
        className={styles.inner}
        style={{ transform: `scale(${scale})`, width: `${100 / scale}%`, padding: "8px" }}
        dangerouslySetInnerHTML={{ __html: rendered || "…" }}
      />
    </div>
  );
}
